import React, {useRef, useEffect} from "react";
import _ from 'lodash';
import { Container, Header } from "./Styled";
import { Button } from "antd";
import { useSelector } from 'react-redux'
import {RootState} from '../../../../model/rootReducer/'
import { Entity } from "../../../../model/intent/types";
import Item from "./Item/Item"
import MenuList, { Item as MenuItem } from "../../../system/menuList";
import { usePrevious } from "../../../../helpers/hooks";

type IntentListProps = {
  onSelect: (entity?: Entity | null) => void
  selectedEntityId: string | undefined | null;
};

const EntityList: React.FunctionComponent<IntentListProps> = props => {
  const entities = useSelector((state: RootState) => state.entity.entities)

  const renderHeader = () =>  {
    return <Header><Button onClick={() => props.onSelect(undefined)}>+</Button></Header>
  }

  return (
    <Container>
      <MenuList
        header={renderHeader()}
        onSelect={props.onSelect}
        dataSource={entities}
        renderItem={(entity: Entity) => (
          <MenuItem isSelected={entity.id === props.selectedEntityId} onSelect={() => props.onSelect(entity)}> 
            <Item title={entity.title}/>
          </MenuItem> 
        )}
      />
    </Container>
  );
};

export default EntityList;
